import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import GrupoUnidadMedidaGestion from './view/GrUniMed'

export const grupoUnidadMedidaRouteMap = {
  gestion: {
    path: '/grupounidadmedida/gestion',
    name: 'Grupo unidades medida',
    action: 'GRUPO_UNIDADES_MEDIDA',
  },
  registro: {
    path: '/grupounidadmedida/nuevo',
    name: 'Nuevo grupo unidad medida',
    action: 'ADMINISTRAR_UNIDADES_MEDIDA',
  },
  actualizar: {
    path: '/grupounidadmedida/actualizar/:id',
    name: 'Actualizar Grupo unidad Medida',
    action: 'ADMINISTRAR_UNIDADES_MEDIDA',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const grupoUnidadMedidaRoutes = [
  {
    path: grupoUnidadMedidaRouteMap.gestion.path,
    element: (
      <OperacionesProvider>
        <GrupoUnidadMedidaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default grupoUnidadMedidaRoutes
